// @flow
/* eslint-disable camelcase */

import React, { memo } from 'react';
import history from 'client/utils/history';
import Styles from './styles';

type Props = {
  data : {
    title : string,
    link_key : number,
    cover : string,
  },
  size : number,
};

export default memo(({ data, size } : Props) => (
  <Styles
    {...{
      className: 'item tagItem selectableItem',
      route: `/${data.id}/${data.name}`,
      onClick: () => history.push(`/${data.id}/${data.name}`),
      clickable: 'true',
      size,
    }}
  >
    <h5 className="categoryTitle">{data.name}</h5>
  </Styles>
));
